import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://cixmhnrbwaeimwwfrftq.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNpeG1obnJid2FlaW13d2ZyZnRxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIxNjUxOTksImV4cCI6MjA3Nzc0MTE5OX0.9hLmaNPKUzmqCrtif4y9Fq4cnPlvQh8zfzPe7X2dlFk'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  },
  global: {
    headers: {
      'apikey': supabaseAnonKey
    }
  }
})
